import { Grid } from "@mui/material";
import MDBox from "components/MDBox";


import { FormTitle,Text,SelectField,SwitchField } from "ui-components/Form";

const option = {
  movementType: ["FAST","MEDIUM","SLOW"],
  locationType: ["Pallet", "Shelve", "Block", "Double Deep"],
  mheType: ["Pallet Truck", "ForkLift", "Reach Truck"],
  locCategory: ["Pick And Drop"],
};

function LocationInfo({ values,whOptions=[],zoneOptions=[],formRender, control, errors, getValues, setValue, mode = "ADD", locDimGrpOptions = [] }) {
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Location Information" : "Location Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { disabled, editable, size, ...data } = property;
              const xs = size ? size : 12 / rows.length;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(disabled && { disabled }),
                ...(mode === "EDIT" && editable === false && { disabled: true,type:"text" }),
                ...(data.name==="dropZone"&&values.locCategory===null&&{ disabled: true })
              };
              let renderField;
              switch (fieldProps.type) {
                case "text":
                case "number":
                  renderField = <Text field={fieldProps} />;
                  break;
                case "select":
                  let options = [];
                  switch (data.name) {
                    case "warehouseCode":
                      options = whOptions
                      break;
                    case "zoneID":
                      options = zoneOptions
                      break;
                    case "movementType":
                      options = option.movementType;
                      break;
                    case "locationType":
                      options = option.locationType;
                      break;
                    case "mheType":
                      options = option.mheType;
                      break;
                    case "locCategory":
                      options = option.locCategory;
                      break;
                    case "locDimGrp":
                      options = locDimGrpOptions
                      break;
                  }
                  renderField = <SelectField field={fieldProps} options={options} />;
                  break;
                case "switch":
                  renderField = <SwitchField field={fieldProps} />;
                  break;
              }

              return (
                <Grid item xs={xs} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default LocationInfo;
